module.exports = __webpack_public_path__ + "88d6899fcd01aa8d2e6b0a32309311c2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/googley-20.png
// module id = 1498
// module chunks = 0